// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__1kQ6Y","tabHeader":"tab_tabHeader__1kRnU"};